import types from '../actions/types'
import errorHelper from '../helpers/error.helper'
import utils from '../helpers/util.helper'

export default function (state = null, action) {
  switch (action.type) {
    case `${types.LOAD_ENTERPRISE}_PENDING`:
      return { ...state }
    case `${types.LOAD_ENTERPRISE}_FULFILLED`:
      return { ...state, errors: {}, ...action.payload.data }
    case `${types.LOAD_ENTERPRISE}_REJECTED`:
      return { errors: action.payload.response.data }

    case `${types.ADD_ENTERPRISE}_PENDING`:
      return { ...state }
    case `${types.ADD_ENTERPRISE}_FULFILLED`:
      return { ...state, errors: {}, ...action.payload.data }
    case `${types.ADD_ENTERPRISE}_REJECTED`:
      return { ...state, errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.UPDATE_ENTERPRISE}_PENDING`:
      return { ...state }
    case `${types.UPDATE_ENTERPRISE}_FULFILLED`:
      return { ...state, errors: {}, ...action.payload.data }
    case `${types.UPDATE_ENTERPRISE}_REJECTED`:
      return { ...state, errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.ADD_ENTERPRISE_DOMAIN}_PENDING`:
      return { ...state }
    case `${types.ADD_ENTERPRISE_DOMAIN}_FULFILLED`:
    {
      const newState = { ...state, errors: {} }
      newState.EnterpriseDomains.push(action.payload.data)
      return newState
    }
    case `${types.ADD_ENTERPRISE_DOMAIN}_REJECTED`:
      return { ...state, errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.FETCH_ENTERPRISE_DOMAIN_SAML_METADATA}_PENDING`:
      return { ...state }
    case `${types.FETCH_ENTERPRISE_DOMAIN_SAML_METADATA}_FULFILLED`:
    {
      const newDomains = [...state.EnterpriseDomains]
      const data = utils.camelCaseToSnakeCollection(action.payload.data)
      newDomains[action.meta.index].SamlAuthenticationProvider = data
      return { ...state, errors: {}, EnterpriseDomains: newDomains }
    }
    case `${types.FETCH_ENTERPRISE_DOMAIN_SAML_METADATA}_REJECTED`:
      return { ...state, errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.FETCH_ENTERPRISE_USERS}_PENDING`:
      return { ...state }
    case `${types.FETCH_ENTERPRISE_USERS}_FULFILLED`:
      return { ...state, users: action.payload.data, errors: [] }
    case `${types.FETCH_ENTERPRISE_USERS}_REJECTED`:
      return { ...state, users: [], errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.UPDATE_ENTERPRISE_USER}_PENDING`:
      return { ...state }
    case `${types.UPDATE_ENTERPRISE_USER}_FULFILLED`:
      return { ...state, updated: action.payload.data }
    case `${types.UPDATE_ENTERPRISE_USER}_REJECTED`:
      return { ...state, updated: {}, errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.CLAIM_ENTERPRISE_USERS}_PENDING`:
      return { ...state }
    case `${types.CLAIM_ENTERPRISE_USERS}_FULFILLED`:
      return { ...state, users: action.payload.data, errors: [] }
    case `${types.CLAIM_ENTERPRISE_USERS}_REJECTED`:
      return { ...state, users: [], errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.FORCE_SAML_ON_ENTERPRISE_USERS}_PENDING`:
      return { ...state }
    case `${types.FORCE_SAML_ON_ENTERPRISE_USERS}_FULFILLED`:
      return { ...state, users: action.payload.data, errors: [] }
    case `${types.FORCE_SAML_ON_ENTERPRISE_USERS}_REJECTED`:
      return { ...state, users: [], errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    case `${types.UPDATE_ENTERPRISE_DOMAIN_SAML}_PENDING`:
      return { ...state }
    case `${types.UPDATE_ENTERPRISE_DOMAIN_SAML}_FULFILLED`:
      return { ...state, saml: action.payload.data, errors: [] }
    case `${types.UPDATE_ENTERPRISE_DOMAIN_SAML}_REJECTED`:
      return { ...state, saml: {}, errors: errorHelper.buildErrors(action.payload.response.data.errors) }

    default:
      return state
  }
}
